import { Button, Link, Stack } from '@mui/material'
import React from 'react'
import { useParams, useNavigate } from "react-router-dom";
import { NORMALIZER_ACTION, NORMALIZER_APPROVE,NORMALIZER_ACCEPTANCE, NORMALIZER_REJECT,NORMALIZER_REJECTION } from '../../../constants/routes/Routing';

const NormalizerFooterButton = (props:any) => {
  const navigate = useNavigate();
  const { employee_id } = useParams();

  const handleReject = () => {
    navigate(`${NORMALIZER_REJECT}/employee/${employee_id}`)
  }
  const handleAccept = () => {
      navigate(`${NORMALIZER_ACCEPTANCE}/employee/${employee_id}`)
  }
  const handleCancel = () =>{
    navigate('/normalizer', { state: { from: 1 } });

  }
  return (
    <Stack justifyContent="center" spacing={2} paddingTop="30px" direction="row">
    <>
                  <Button
                    variant="outlined"
                    style={{
                      backgroundColor: "Transparent",
                      fontSize: "15px",
                      fontWeight: 400,
                      textTransform: "none",
                      color: "#3e8cb5",
                      borderColor: "#3E8CB5",
                      height: "35px",
                      fontFamily: "Arial",
                      width: "70px",
                    }}
                    onClick={() => {
                      handleAccept();
                    }}
                  >
                    Accept
                  </Button>

                  <Button
                    variant="outlined"
                    style={{
                      backgroundColor: "Transparent",
                      fontSize: "15px",
                      fontWeight: 400,
                      textTransform: "none",
                      color: "#3e8cb5",
                      borderColor: "#3E8CB5",
                      height: "35px",
                      fontFamily: "Arial",
                      width: "70px",
                    }}
                    onClick={() => {
                      handleReject();
                    }}
                  >
                    Reject
                  </Button>

                    <Button
                      variant="outlined"
                      style={{
                        backgroundColor: "Transparent",
                        fontSize: "15px",
                        fontWeight: 400,
                        textTransform: "none",
                        color: "#3e8cb5",
                        borderColor: "#3E8CB5",
                        height: "35px",
                        fontFamily: "Arial",
                        width: "70px",
                      }}
                      onClick ={() => {handleCancel()}}
                    >
                      Cancel
                    </Button>
                </>
          </Stack>
  )
}

export default NormalizerFooterButton